import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration } from '@angular/platform-browser';
import { BlockUIModule } from 'ng-block-ui';
import { environment } from '../environments/environment';
import { HammerModule } from '@angular/platform-browser';

import { routes } from './app.routes';
import { errorInterceptor } from '../sdk/services/core/httpinterceptor.service';

import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';

import { RoutesService } from '../sdk/services/custom/routes.service';
import { AuthService } from '../sdk/services/core/auth.service';
import { ShowingApi } from '../sdk/services/custom/showings.service';
import { ListingApi } from '../sdk/services/custom/listing.service';
import { DocumentApi } from '../sdk/services/custom/documents.service';
import { DynamicScriptLoaderService } from '../sdk/services/custom/script-store';
import { NavbarRerenderService } from '../sdk/services/helper/navbar-rerender.service';
import { PubSubService } from '../sdk/services/core/pub-sub.service';
import { MiscHelperService } from '../sdk/services/custom/miscHelperService.service';
import { GoogleApiService } from '../sdk/services/helper/googleapi.service';
import { ListAPropertyService } from '../sdk/services/helper/listaproperty.service';
import { GlobalErrorHandler } from '../sdk/services/core/global-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    })),
    provideHttpClient(withInterceptors([errorInterceptor])),
    provideAnimationsAsync(),
    // Only for SSR + browser hydration. `ng serve` is CSR-only; hydration here often causes
    // blank / broken UI after live reload. Enabled in production (environment.prod.ts).
    ...(environment.enableClientHydration ? [provideClientHydration()] : []),
    importProvidersFrom(
      BlockUIModule.forRoot(),
      HammerModule,
    ),
    { provide: NZ_I18N, useValue: en_US },
    RoutesService,
    AuthService,
    ShowingApi,
    ListingApi,
    DocumentApi,
    DynamicScriptLoaderService,
    NavbarRerenderService,
    PubSubService,
    MiscHelperService,
    GoogleApiService,
    ListAPropertyService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
